// removed by extract-text-webpack-plugin
module.exports = {"project-list":"_13qOQWnj","projectList":"_13qOQWnj","project-container":"_18FiFi3y","projectContainer":"_18FiFi3y","project":"_2BRqAfP2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectList/ProjectList.pcss
// module id = 837
// module chunks = 0